var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAnalogProject)?_c('AnalogPage'):_c('HomePage')
}
var staticRenderFns = []

export { render, staticRenderFns }